import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import { CREATE_INFRA_ZONE, ZONE_LIST } from "./type";

export const createValet = (projectId, name) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {'project_id': projectId, name: name},
            `${Config.valet.infraZone}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CREATE_INFRA_ZONE,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: CREATE_INFRA_ZONE,
            payload: null,
        });
        return true;
    }
}

/**
 *
 * @param projectId
 * @returns {(function(*): Promise<boolean|undefined>)|*}
 */
export const getZoneList = (projectId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.valet.zoneList}?project_id=`+projectId
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: ZONE_LIST,
                payload: data.response.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: ZONE_LIST,
            payload: null,
        });
        return true;
    }
}